import Selectr from "mobius1-selectr";
import SimpleScrollbar from "simple-scrollbar";

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default {
  name: "selectr",

  componentDidMount() {
    this.selectr = new Selectr(this.el, {
      searchable: false
    });

    this.selectr.on("selectr.init", () => {
      var el = this.el.parentNode.querySelector(".selectr-options-container");
      SimpleScrollbar.initEl(el);
    });
  }
};
